module.exports = __webpack_public_path__ + "img/000.6101391c.jpg";